/* RESPONSIBLE TEAM: team-proactive-support */
// app/lib/content_service/constants/saved_views/saved_view_data_formats.rb

export enum DataFormat {
  ARTICLES = 0,
  OUTBOUND = 1,
}
